import { TransactionActivity, TransactionActivityDisplay } from "types/audit/transaction-activity";

export const transformTransactionActivity = (currentRevision: TransactionActivity, previousRevision?: TransactionActivity): TransactionActivityDisplay => {
  return {
    timestamp: currentRevision.revision.timestamp,
    action: buildActivityAction(currentRevision),
    modifiedBy: currentRevision.transaction.lastUpdatedBy ?? "",
    description: buildActivityDescription(currentRevision, previousRevision),
    booking: currentRevision.transaction.booking?.toString() ?? "N/A"
  }
}

const buildActivityAction = (activity: TransactionActivity): string => {
  if (activity.type === "ADD") {
    return activity.transaction.inbound
      ? "GATE IN"
      : "GATE OUT";
  } else if (activity.type === "MOD") {
    if(activity.updatedFields.some(field => ["gateEdiFileExecutionId", "statusEdiFileExecutionId", "liftEdiFileExecutionId"].includes(field))) {
      return "EDI sent"
    } else {
      return activity.transaction.deleted === true ? "TRANSACTION DELETED" : "EDIT TRANSACTION CHANGE";
    }
  }

  // unreachable since we don't support deleting transactions (yet)
  return "EDIT TRANSACTION CHANGE"
}

const buildActivityDescription = (currentRevision: TransactionActivity, previousRevision?: TransactionActivity): JSX.Element | string => {
  if (currentRevision.type === "ADD" || currentRevision.transaction.deleted === true) {
    return ""
  } else if (currentRevision.updatedFields.length === 0 || !previousRevision) {
    return "NO CHANGES";
  } else if(currentRevision.updatedFields.some(
    field => ["gateEdiFileExecutionId", "statusEdiFileExecutionId", "liftEdiFileExecutionId"].includes(field)
  )) {
    const label = currentRevision.updatedFields.includes("liftEdiFileExecutionId")
      ? "Lift Edi"
      : currentRevision.updatedFields.includes("statusEdiFileExecutionId")
      ? "Status Edi"
      : "Gate Edi";
    const executionId = currentRevision.updatedFields.includes("liftEdiFileExecutionId")
      ? currentRevision.transaction.liftEdiFileExecutionId
      : currentRevision.updatedFields.includes("statusEdiFileExecutionId")
      ? currentRevision.transaction.statusEdiFileExecutionId
      : currentRevision.transaction.gateEdiFileExecutionId;
    return (
      <a
        href={`https://www.stedi.com/app/core/file-executions/${executionId}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {label}
      </a>
    );
  }

  let description = currentRevision.updatedFields.some(
      field => ["gateEdiFileExecutionId", "statusEdiFileExecutionId", "liftEdiFileExecutionId"].includes(field)
    )
    ? "View EDI at:"
    : "CHANGED FIELD(S) ";
  const changelog: any[] = [];

  for (const field of currentRevision.updatedFields) {
    switch (field) {
      case "inbound":
        changelog.push(`INBOUND FROM '${String(previousRevision.transaction.inbound)}' TO '${String(currentRevision.transaction.inbound)}'`);
        break;
      case "draft":
        changelog.push(`DRAFT FROM '${String(previousRevision.transaction.draft)}' TO '${String(currentRevision.transaction.draft)}'`);
        break;
      case "notes":
        changelog.push(`NOTES FROM '${String(previousRevision.transaction.notes)}' TO '${String(currentRevision.transaction.notes)}'`);
        break;
      case "driverName":
        changelog.push(`DRIVER NAME FROM '${String(previousRevision.transaction.driverName)}' TO '${String(currentRevision.transaction.driverName)}'`);
        break;
      case "cdlNumber":
        changelog.push(`CDL NUMBER FROM '${String(previousRevision.transaction.cdlNumber)}' TO '${String(currentRevision.transaction.cdlNumber)}'`);
        break;
      case "licensePlate":
        changelog.push(`LICENSE PLATE FROM '${String(previousRevision.transaction.licensePlate)}' TO '${String(currentRevision.transaction.licensePlate)}'`);
        break;
      case "truckNumber":
        changelog.push(`TRUCK NUMBER FROM '${String(previousRevision.transaction.truckNumber)}' TO '${String(currentRevision.transaction.truckNumber)}'`);
        break;
      default:
        break;
    }
  }

  return `${description} ${changelog.join(',')}.`.toUpperCase();
}